import React, { Component } from 'react';
import { Button, Icon } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import { Drawer, BasicView, DetailView } from "@pearson-components/drawer";
import { HelpPageContent } from "../../_helpers";


import configJson from '../../_helpers/config.json';
const basePath=configJson["CommonConstants"]["Base_path"]

export default class PearsonDrawer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPageInitialized: false,
      drawerIsOpen: this.props.drawerIsOpen,
      text: {
        headerTitle: "Help",
        headerTitleSR     : "Help drawer",
        closeButtonSRText : "Close",
        backButtonText    : "Back"
      },
      helpPageContent: "",
      userRole: ''
    };
    this.drawerHandler = this.drawerHandler.bind(this);
    this.getHelpPageContent = this.getHelpPageContent.bind(this);
  };

  componentWillMount() {
    let user = JSON.parse(localStorage.getItem('user'));
    let roles=user?user.roles:'Anonymous';
    if(roles){
      if (roles.includes("Super Admin")) {
        this.setState({ userRole: "superAdmin" });
      }
      else if (roles.includes("Admin")) {
        this.setState({ userRole: "admin" });
      }
      else if (roles.includes("User")) {
        this.setState({ userRole: "user" });
      }
      else{
        this.setState({ userRole: roles });
      }
    }
  }

  drawerHandler() {
    this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
  };

  getHelpPageContent() {
    let { userRole } = this.state;
    if (userRole) {
      const playlist = window.location.pathname.includes('playlist');
      const search = window.location.pathname.includes('search');
      const home = window.location.pathname.includes('dashboard');
      const collection = window.location.pathname.includes('collection');
      const upload = window.location.pathname.includes('upload-video');
      const bookcode = window.location.pathname.includes('bookcode');
      const changePassword = window.location.pathname.includes('changepassword');
      const unallocatedVideos = window.location.pathname.includes('unallocated-videos');
      const login = window.location.pathname.includes('login');
      const topic = window.location.pathname.includes('topic') ||  window.location.pathname.includes('subtopic');
      const adminUsers = window.location.pathname.includes('admin-users');
      const uploadSpreadsheet = window.location.pathname.includes('upload-spreadsheet');
      const courseConfiguration = window.location.pathname.includes('coursesetting');
      const forgotPasswordPage = window.location.pathname.includes('forgotPasswordPage-login');
      const videoPlayer = window.location.pathname.includes('LibraryDetail');

      if (topic) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].topicSubTopic ,isPageInitialized:true });
      }
      else if (search) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].search ,isPageInitialized:true });
      }
     else if (courseConfiguration) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].courseConfiguration ,isPageInitialized:true });
      }
      else if ( localStorage.getItem("forgotPasswordPage") =='true') {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].forgotPasswordPage ,isPageInitialized:true });
      }
     else if (window.location.pathname ===basePath+ "/tag") {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].tag ,isPageInitialized:true });
      }
      else if (uploadSpreadsheet) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].uploadSpreadsheet ,isPageInitialized:true });
      }
     else if (window.location.pathname === basePath+"/favorites") {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].favorite ,isPageInitialized:true });
      }
      else if (adminUsers) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].adminUsers ,isPageInitialized:true });
      }
     else if (unallocatedVideos) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].unallocatedVideos ,isPageInitialized:true });
      }
      else if (login) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].adminLogin ,isPageInitialized:true });
      }
     else if (changePassword) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].changePassword ,isPageInitialized:true });
      }
     else if (playlist) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].playlist ,isPageInitialized:true });
      }
      else if (bookcode) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].bookcode ,isPageInitialized:true });
      }
      else if (upload) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].upload ,isPageInitialized:true });
      }
      else if (collection) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].collection ,isPageInitialized:true });
      }
     else if (home) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].home ,isPageInitialized:true });
      }
      else if (videoPlayer) {
        this.setState({ drawerIsOpen: true, helpPageContent: HelpPageContent[userRole].videoPlayer ,isPageInitialized:true });
      }
      else {
        this.setState({ drawerIsOpen: true, helpPageContent: "Home page help content" ,isPageInitialized:true});
      }
    }
   
  };

  componentDidUpdate(){
    this.render();
  }

  render() {
    const { drawerIsOpen, text, helpPageContent, isPageInitialized } = this.state;
    return (
      <div>
        <Button aria-label="Help" btnIcon onClick={() => { this.getHelpPageContent(); }} title="Help"> <Icon name="help-fill-18"></Icon> <span className="MobileHelp">Help</span></Button>
        {
          isPageInitialized ?
            <Drawer
              id="helpDrawer"
              drawerTop="70px"
              drawerOpen={drawerIsOpen}
              position="right"
              text={text}
              skipTo="detailViewId"
              basicViewClick={(e) => console.log('tags...' + e.currentTarget.innerHTML)}
              drawerHandler={this.drawerHandler}
              appRootId="root">
              <div>
                <DetailView id="detailViewId" myKind="DetailView">
                <div dangerouslySetInnerHTML={{__html: helpPageContent}} />
                </DetailView>
              </div>
            </Drawer>
            : ''
        }
      </div>
    )
  }
};




// WEBPACK FOOTER //
// ./src/components/pearson-drawer/pearson-drawer.js